export const PAYMENT_FINISHED_MESSAGE = 'PAYMENT_FINISHED_MESSAGE';

export const PAYMENT_STATUS_SUCCESS = 'PAYMENT_STATUS_SUCCESS';
export const PAYMENT_STATUS_FAILURE = 'PAYMENT_STATUS_FAILURE';

export const MPGS_BETA_FEATURE = 'MPGS_PAYMENT_FEATURE';
